import { Link } from 'react-router-dom';
import { ArrowLeft, Scales } from '@phosphor-icons/react';

export default function TermsOfService() {
  const today = new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white px-4 sm:px-6 py-10" data-testid="terms-page">
      <div className="max-w-3xl mx-auto">
        <Link to="/" className="inline-flex items-center gap-2 text-[#A1A1AA] hover:text-white transition-colors mb-8 text-sm" data-testid="terms-back-link">
          <ArrowLeft weight="bold" className="w-4 h-4" /> Back to GRIT.FIT
        </Link>
        <div className="flex items-center gap-3 mb-8">
          <Scales weight="fill" className="w-10 h-10 text-[#FF3B30]" />
          <div>
            <div className="label-tactical text-[#FF3B30]">Legal</div>
            <h1 className="text-4xl sm:text-5xl font-black tracking-tighter">TERMS OF SERVICE</h1>
          </div>
        </div>
        <p className="text-[#71717A] text-sm mb-10">Last updated: {today}</p>

        <div className="space-y-8 text-[#D4D4D8] text-sm sm:text-base leading-relaxed">
          <section className="border border-[#FF9500]/30 bg-[#FF9500]/5 p-5">
            <h2 className="text-xl font-bold text-[#FF9500] mb-3">⚠️ Health &amp; Safety Notice</h2>
            <p>GRIT.FIT provides fitness content for informational purposes. It is NOT medical advice. Consult a physician before starting any exercise program, especially if you have health conditions, injuries, or are pregnant. Exercise at your own risk. Stop immediately if you feel pain, dizziness, or unusual symptoms. By using GRIT.FIT you accept sole responsibility for your physical safety.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">1. Acceptance</h2>
            <p>By creating an account or using GRIT.FIT, you agree to these Terms. If you don't agree, don't use the service. These Terms form a binding contract between you and GRIT.FIT ("we", "us", "our").</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">2. Your Account</h2>
            <ul className="list-disc ml-6 space-y-1 text-[#A1A1AA]">
              <li>You must be at least 13 years old (16 in the EU)</li>
              <li>You're responsible for keeping your password secure</li>
              <li>You must provide accurate account info</li>
              <li>One account per person</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">3. Subscription &amp; Billing (Pro Tier)</h2>
            <ul className="list-disc ml-6 space-y-1 text-[#A1A1AA]">
              <li>Pro subscriptions auto-renew until cancelled</li>
              <li>Cancel anytime from your billing portal — you retain Pro access until the end of the current paid period</li>
              <li>All payments processed securely by Stripe</li>
              <li>Refunds: within 7 days of purchase if you haven't used any Pro features, handled case-by-case</li>
              <li>Pricing may change with 30 days' notice to existing subscribers</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">4. Acceptable Use</h2>
            <p>You agree not to:</p>
            <ul className="list-disc ml-6 space-y-1 text-[#A1A1AA] mt-2">
              <li>Harass, threaten, or impersonate other users (including your accountability buddy)</li>
              <li>Attempt to reverse-engineer, scrape, or disrupt the service</li>
              <li>Upload content you don't own or have permission to share</li>
              <li>Use GRIT.FIT for any illegal purpose</li>
              <li>Create fake accounts or manipulate leaderboards</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">5. AI-Generated Content</h2>
            <p>Workout plans are generated by large language models and are provided as-is. They're educated suggestions based on your stated goals and level — not personalized medical or training prescriptions. Always use your judgment.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">6. Intellectual Property</h2>
            <p>GRIT.FIT, its logo, and content are our property. Your workout data is yours — we only have a limited license to process it to run the service. You can export or delete it anytime.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">7. Disclaimer &amp; Limitation of Liability</h2>
            <p>The service is provided "as is" without warranties of any kind. To the maximum extent allowed by law, we are not liable for: physical injury from exercise, data loss, service interruptions, or indirect damages. Our total liability is capped at what you paid us in the last 12 months.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">8. Termination</h2>
            <p>You can delete your account anytime. We can suspend accounts that violate these Terms, with notice where feasible.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">9. Changes</h2>
            <p>We may update these Terms. Material changes will be announced in-app or by email. Continued use after the effective date = acceptance.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">10. Contact</h2>
            <p>Reach us via the contact info on the landing page or in your Stripe billing portal.</p>
          </section>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col sm:flex-row gap-3 justify-between text-sm">
          <Link to="/privacy" className="text-[#A1A1AA] hover:text-white transition-colors" data-testid="terms-to-privacy">→ Privacy Policy</Link>
          <Link to="/" className="text-[#A1A1AA] hover:text-white transition-colors">← Back to GRIT.FIT</Link>
        </div>
      </div>
    </div>
  );
}
